<template>
  <ion-page id="signoff-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">

        <ion-item>
           <h2>{{ signoffText }}</h2>
        </ion-item>
        <div v-if="showLogoffButton">
          <ion-item>
            <ion-checkbox label-placement="end" @ionChange="rememberEmail = !rememberEmail" checked>{{ t("Remember my email address") }}</ion-checkbox>
          </ion-item>
          <ion-item>
            <ion-button expand="full" size="large" @click="doLogoff()" >{{ t("Signoff") }}</ion-button>
          </ion-item>
        </div>
        <div v-if="whichMenu == 'buttons'">
          <ion-item>
            <ion-button expand="full" size="large" @click="returnToButtonMenu()" >{{ t("Return to Big Button Menu") }}</ion-button>
          </ion-item>
        </div>
    </div>
  </ion-content>
  </ion-page>
</template>

<script setup>

import { IonLabel,IonCheckbox, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

import { ref, watch } from 'vue';
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { availableWidthHeight } from '@/composables/screenSize'

const emit = defineEmits(['signin-status-change','next-item-click'])

const connectionStore = useConnectionStore()
const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const whichMenu = localStorage.getItem("whichMenu")
const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

const TOOLBAR_DONE = 0

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })
//console.log("**** logoff initial screensize", windowSizeRef.value)

const signoffText = ref(t("Confirm Signoff"))
const showLogoffButton = ref(true)
const rememberEmail = ref(true)

const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

updateWidthHeights()

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    menuTrigger.value++
    updateWidthHeights()
  })

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

function doLogoff () {
  //console.log("****** LOGOFF")
  const connectionStore = useConnectionStore()
  connectionStore.setUserCookieDummy("","1")
  
  menuTrigger.value++
  
  if (rememberEmail.value == false)
    connectionStore.setEmailAddress("")

  signoffText.value = t("Signed off")
  showLogoffButton.value = false
  doStartupCheck(true,afterStartupCallbackRoutine)

}

function returnToButtonMenu() {
  emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
}

const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };
  
function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  updateWidthHeights()
  emit('signin-status-change',false)
}

</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>